import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type {
    AuthorizedMedicationInfoFragment,
    OfferCoverageCard,
    UnknownMedicationInfoFragment,
} from '../../../../graphql/generated/graphql';
import { useProgramTerms } from '../../../../hooks/use-program-terms';
import {
    SavingsCardDetailsLabel,
    SavingsCardDetailsValue,
    SavingsCardPatientInfo,
    ProgramSavingsCard,
    SavingsCardData,
} from '../../../common/savings-card';

export type InsuranceSavingsCardProps = {
    coverageCard: OfferCoverageCard;
    medication:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment;
};

export const InsuranceSavingsCard: FC<InsuranceSavingsCardProps> = ({
    coverageCard,
    medication,
}) => {
    const { t } = useTranslation('lilly');

    const terms = useProgramTerms(medication, 'insurance')!;

    return (
        <ProgramSavingsCard
            patientInfo={
                <SavingsCardPatientInfo>
                    <SavingsCardDetailsLabel>
                        {t('savingsCard.data.memberId')}
                    </SavingsCardDetailsLabel>
                    <SavingsCardDetailsValue>
                        {coverageCard.cardHolderId}
                    </SavingsCardDetailsValue>
                </SavingsCardPatientInfo>
            }
            savingsCard={terms.savingsCard!}
        >
            <SavingsCardData coverageCard={coverageCard} />
        </ProgramSavingsCard>
    );
};
